module.exports = "/lucky-balls/img/infobox/info_Box_026.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_026.png
// module id = 1091
// module chunks = 0